<div class="grid">

    <div class="col-12 flex flex-column gap-2">
        <mvs-dm-object-documents-consultant class="mvs-widget h-full"
                [objectIdentifier]="objectIdentifier"
                layoutVariation="customer"
                [showCreateTicketButton]="true"
        ></mvs-dm-object-documents-consultant>
    </div>
</div>
